import React from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { getSecurityPoints, getCompliance } from "@/data/site";
import { ShieldCheck, Lock } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Sicurezza() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Sicurezza", "Security", "Sicherheit"), L("L'approccio alla sicurezza di Recovers Crypto: non-custodial, cifratura, audit e accesso controllato.", "The Recovers Crypto security approach: non-custodial, encryption, audit and controlled access.", "Der Sicherheitsansatz von Recovers Crypto: non-custodial, Verschlüsselung, Audit und kontrollierter Zugriff."));
  const security = getSecurityPoints(lang);
  const compliance = getCompliance(lang);
  return (
    <div>
      <PageHero eyebrow={L("Sicurezza", "Security", "Sicherheit")} title={L("Sicurezza e riservatezza", "Security and confidentiality", "Sicherheit und Vertraulichkeit")}
        subtitle={L("Un approccio non-custodial con misure tecniche e organizzative a protezione delle informazioni del caso.", "A non-custodial approach with technical and organizational measures to protect case information.", "Ein Non-custodial-Ansatz mit technischen und organisatorischen Maßnahmen zum Schutz der Fallinformationen.")} />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {security.map((p) => (
            <div key={p} className="flex items-center gap-3 rounded-lg border border-white/10 bg-navy-paper px-4 py-3.5 text-sm text-slate-300">
              <Lock className="h-4 w-4 text-cyanx shrink-0" />{p}
            </div>
          ))}
        </div>
        <div className="mt-14 rounded-xl border border-gold/20 bg-gold/5 p-6">
          <h3 className="font-heading text-lg font-medium text-white flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-gold" />{L("Cosa non chiediamo mai", "What we never ask for", "Was wir niemals verlangen")}</h3>
          <p className="mt-3 text-sm text-slate-300">
            {L("Non chiediamo né accettiamo mai seed phrase complete, chiavi private, password complete, PIN di hardware wallet o codici di autenticazione degli exchange, in nessun modulo, uploader o messaggio.", "We never ask for or accept full seed phrases, private keys, full passwords, hardware wallet PINs or exchange authentication codes, in any form, uploader or message.", "Wir verlangen und akzeptieren niemals vollständige Seed-Phrasen, private Schlüssel, vollständige Passwörter, Hardware-Wallet-PINs oder Exchange-Authentifizierungscodes – in keinem Formular, Uploader oder in keiner Nachricht.")}
          </p>
        </div>
        <div className="mt-14">
          <h3 className="font-heading text-xl font-medium text-white mb-4">{L("Posizionamento e limiti", "Positioning and limits", "Positionierung und Grenzen")}</h3>
          <ul className="space-y-2.5">
            {compliance.map((c) => <li key={c} className="text-sm text-slate-400 border-l-2 border-white/10 pl-4">{c}</li>)}
          </ul>
        </div>
      </section>
    </div>
  );
}
